import { generateUploaderEventHook } from "@rpldy/shared-ui";
import { RETRY_EVENT } from "@rpldy/retry";
const useRetryListener = generateUploaderEventHook(RETRY_EVENT, false);
export default useRetryListener;